import { FoodBookingModel } from '@xeetr/types/models'

export const AmountColumn = (booking: FoodBookingModel) => booking?.amount?.toString()
